(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["luxury-brand-directory"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('brand-directory')){
  customElements.define('brand-directory',class extends HTMLElement{
    connectedCallback(){
      if(this.ready)return;this.ready=true;this.letter='all';this.search=this.querySelector('[data-brand-search]');this.cards=[...this.querySelectorAll('[data-brand-card]')];this.buttons=[...this.querySelectorAll('[data-letter]')];this.status=this.querySelector('[data-brand-status]');this.clear=this.querySelector('[data-clear-search]');
      this.search.addEventListener('input',()=>this.filter());this.clear.addEventListener('click',()=>{this.search.value='';this.filter();this.search.focus();});this.buttons.forEach(b=>b.addEventListener('click',()=>{this.letter=b.dataset.letter;this.filter();}));
    }
    filter(){const query=this.search.value.trim().toLocaleLowerCase();let count=0;this.cards.forEach(c=>{const visible=(this.letter==='all'||c.dataset.brandLetter===this.letter)&&c.dataset.brandName.includes(query);c.hidden=!visible;if(visible)count++;});this.buttons.forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.letter===this.letter)));this.status.textContent=count+' '+this.status.dataset.countLabel;this.clear.hidden=!query;this.querySelector('[data-brand-empty]').hidden=count>0;}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["luxury-brand-hero"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('luxury-brand-hero')){
  customElements.define('luxury-brand-hero',class extends HTMLElement{
    connectedCallback(){
      this.slides=[...this.querySelectorAll('[data-slide]')];this.nav=[...this.querySelectorAll('[data-go]')];this.index=0;this.timer=null;this.paused=false;this.hovered=false;this.focused=false;this.reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;this.mobileMedia=window.matchMedia('(max-width: 749px)');this.onViewportChange=()=>this.sync();this.mobileMedia.addEventListener('change',this.onViewportChange);
      this.querySelector('[data-next]').addEventListener('click',()=>this.show(this.index+1,true));this.querySelector('[data-previous]').addEventListener('click',()=>this.show(this.index-1,true));this.nav.forEach((b,i)=>b.addEventListener('click',()=>this.show(i,true)));
      this.querySelector('[data-pause]').addEventListener('click',()=>{this.paused=!this.paused;this.updatePause();this.sync();});
      this.addEventListener('mouseenter',()=>{this.hovered=true;this.sync();});this.addEventListener('mouseleave',()=>{this.hovered=false;this.sync();});this.addEventListener('focusin',event=>{this.focused=event.target.matches(':focus-visible');this.sync();});this.addEventListener('focusout',()=>setTimeout(()=>{this.focused=this.contains(document.activeElement)&&document.activeElement.matches(':focus-visible');this.sync();},0));
      this.addEventListener('keydown',e=>{if(e.key==='ArrowRight'){e.preventDefault();this.show(this.index+1,true);}if(e.key==='ArrowLeft'){e.preventDefault();this.show(this.index-1,true);}});
      this.visibility=()=>this.sync();document.addEventListener('visibilitychange',this.visibility);this.editor=e=>{const slide=e.target.closest('[data-slide]');if(slide&&this.contains(slide)){this.paused=true;this.show(Number(slide.dataset.slide),true);this.updatePause();}};document.addEventListener('shopify:block:select',this.editor);
      this.querySelectorAll('video').forEach(v=>{v.addEventListener('playing',()=>v.classList.add('is-playing'));v.addEventListener('error',()=>v.classList.remove('is-playing'));});
      this.updatePause();this.sync();
    }
    disconnectedCallback(){clearTimeout(this.timer);this.mobileMedia.removeEventListener('change',this.onViewportChange);document.removeEventListener('visibilitychange',this.visibility);document.removeEventListener('shopify:block:select',this.editor);this.querySelectorAll('video').forEach(v=>v.pause());}
    show(index,announce){this.index=(index+this.slides.length)%this.slides.length;this.slides.forEach((s,i)=>{s.hidden=i!==this.index;s.inert=i!==this.index;});this.nav.forEach((b,i)=>{if(i===this.index)b.setAttribute('aria-current','true');else b.removeAttribute('aria-current');});this.querySelector('[data-current]').textContent=String(this.index+1).padStart(2,'0');if(announce)this.querySelector('[data-announcement]').textContent=this.slides[this.index].getAttribute('aria-label');this.sync();}
    updatePause(){const b=this.querySelector('[data-pause]');b.setAttribute('aria-pressed',String(this.paused));b.setAttribute('aria-label',this.paused?b.dataset.playLabel:b.dataset.pauseLabel);this.querySelector('[data-pause-icon]').textContent=this.paused?'▶':'❚❚';}
    sync(){clearTimeout(this.timer);const stopped=this.paused||document.hidden||this.reduced;this.slides.forEach((s,i)=>{const v=s.querySelector('video');if(!v)return;if(i===this.index&&!stopped&&!this.mobileMedia.matches){if(!v.getAttribute('src'))v.src=v.dataset.src;v.play().catch(()=>{});}else {v.pause();if(this.mobileMedia.matches)v.classList.remove('is-playing');}});if(this.dataset.autoplay==='true'&&!stopped&&!this.focused&&this.slides.length>1)this.timer=setTimeout(()=>this.show(this.index+1,false),this.slides[this.index].querySelector('video')&&!this.mobileMedia.matches?22000:(Number(this.dataset.interval)||8000));}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mp_lead_form"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('change', function(event) {
  if (event.target.matches('[data-mp-lead-path][value="trade"]') && event.target.checked) {
    window.location.assign('/pages/golzar-home-trade-account-application');
  }
});
document.addEventListener('submit', function(event) {
  if (event.target.id === 'MpLeadForm') {
    var selection = event.target.querySelector('[data-mp-lead-path]:checked');
    if (selection && selection.value === 'trade') {
      event.preventDefault();
      event.stopImmediatePropagation();
      window.location.assign('/pages/golzar-home-trade-account-application');
    }
  }
}, true);

  } catch(e) { console.error(e); }
})();
})();
